import { Button, Stack, useTheme } from "@mui/joy";
import { FormattedMessage } from "react-intl";

export default function CancelLessonButtonView({
  onClick,
  loading,
  children,
}: React.PropsWithChildren<{ onClick: () => void; loading: boolean }>) {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.badge,
        backgroundColor: "white",
        borderWidth: `1px 0 0 0`,
        borderStyle: "solid",
        borderColor: "neutral.outlinedBorder",
      }}
    >
      {children}
      <Button
        onClick={onClick}
        loading={loading}
        sx={{
          borderRadius: 0,
          padding: 2,
        }}
        size="md"
        variant="plain"
        color="neutral"
      >
        <FormattedMessage defaultMessage="Отменить запись" />
      </Button>
    </Stack>
  );
}
